import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import React from "react";
import { SVGIcon } from "./SVGIcon";
// NOTE: This needs to stay a function component otherwise downstream icon tooling will not be able
// to find icon nodes via ts-morph since it expects a function node. (We can't switch to variable node)
export function createSVGIcon(path, displayName, defaultProps) {
    var Component = /*#__PURE__*/ React.memo(/*#__PURE__*/ React.forwardRef(function(props, ref) {
        var strictLocalize = useStrictLocalization().strictLocalize;
        var unwrappedDefaultProps = typeof defaultProps === "function" ? defaultProps === null || defaultProps === void 0 ? void 0 : defaultProps(strictLocalize) : defaultProps;
        var _ref = unwrappedDefaultProps !== null && unwrappedDefaultProps !== void 0 ? unwrappedDefaultProps : {}, defaultClass = _ref.className, titleAccess = _ref.titleAccess;
        var _ref1 = props !== null && props !== void 0 ? props : {}, explicitClass = _ref1.className;
        var curriedClass = [
            defaultClass,
            explicitClass
        ].filter(function(c) {
            return !!c;
        }).join(" ");
        return /*#__PURE__*/ _jsx(SVGIcon, _object_spread_props(_object_spread({
            ref: ref,
            titleAccess: titleAccess
        }, unwrappedDefaultProps, props), {
            className: curriedClass,
            children: path
        }));
    }));
    if ("production" !== "production") {
        Component.displayName = "".concat(displayName, "Icon");
    }
    return Component;
}
